import { render, staticRenderFns } from "./SeletoDeUGs.vue?vue&type=template&id=a0cdfd58&scoped=true"
import script from "./SeletoDeUGs.vue?vue&type=script&lang=ts"
export * from "./SeletoDeUGs.vue?vue&type=script&lang=ts"
import style0 from "./SeletoDeUGs.vue?vue&type=style&index=0&id=a0cdfd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cdfd58",
  null
  
)

export default component.exports